import { Box } from '@mui/material';
import React from 'react';
import { CustomLink } from '../Components/CustomLink';
import { NavBar } from '../Components/NavBar';

export function NavPage() {
    return (
        <Box className="container" sx={{ height: '100vh' }} display="flex" flexDirection="column">
            <NavBar hideLinks />
            <CustomLink to="/">About</CustomLink>
            <CustomLink to="/uses">Uses</CustomLink>
        </Box>
    );
}